module.exports = __webpack_public_path__ + "img/right4.2e63eeb5.png";